import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsResolutionTimeRoute: InvariantJiraRoute = {
	name: 'legacy-reports-resolution-time-report',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey=com.atlassian.jira.plugin.system.reports:resolutiontime-report'],
};
